// src/components/blog/BlogRecentPosts.jsx

import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { formatDate, getBlogImageUrl } from '../../utils/blogUtils';

const BlogRecentPosts = memo(({ posts, isDark, onImageError }) => {
  if (!posts.length) return null;

  return (
    <div className={`mb-8 p-6 rounded-xl ${isDark ? 'bg-white/5 border border-white/10' : 'bg-white border border-gray-200'}`}>
      <h3 className={`text-lg font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
        Recent Posts
      </h3>
      <div className="space-y-4">
        {posts.map((post) => (
          <Link 
            to={`/blog/${post.slug}`} 
            key={post.id} 
            className="group flex gap-3"
          >
            <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-gradient-to-br from-blue-500/20 to-blue-700/20">
              <img 
                src={getBlogImageUrl(post.featured_image, post.title)}
                alt={post.title} 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                onError={() => onImageError?.(post.featured_image)}
                loading="lazy"
              />
            </div>
            <div>
              <h4 className={`text-sm font-semibold group-hover:text-blue-500 transition-colors line-clamp-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
                {post.title}
              </h4>
              <p className={`text-xs mt-1 ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                {formatDate(post.published_at)}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
});

BlogRecentPosts.displayName = 'BlogRecentPosts';

export default BlogRecentPosts;

